//Dependencies 

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

//Components

import Hero from './views/Hero/hero';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Hero />} />
      </Routes>
    </Router>
  );
}

export default App;